import {
  Input,
  ViewContainerRef,
  ComponentRef,
  Directive,
  inject,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DynamicRenderService } from '../services/dynamic-render.service';
import { Store } from '@ngrx/store';
import { UserActions, UserState } from '@ups/user';
import { combineLatest } from 'rxjs';
import { DynComponentMapping } from '../mapping-types';
import { PlatformDynamicComponentsToken } from '../tokens';
import { IDynamicModel } from '../models/dynamic.interface';

/* eslint-disable */
@Directive({
  selector: '[dynamicItem]',
  standalone: false,
})
export class DynamicItemDirective {
  dynamicService = inject(DynamicRenderService);
  vcRef = inject(ViewContainerRef);
  // represented as Array because DI token has multi: true set with the provider
  dynComponentMappings = inject<Array<DynComponentMapping>>(
    PlatformDynamicComponentsToken
  );
  store = inject(Store);
  //@Input() config: DrDisplayControlDto;
  @Input() config: IDynamicModel;
  @Input() group: UntypedFormGroup;
  @Input() index: number;
  @Input() disableItem: boolean;

  component: ComponentRef<{
    config: IDynamicModel;
    group: UntypedFormGroup;
    dynamicService: DynamicRenderService;
  }>;

  ngOnInit() {
    // console.log('dynComponentMapping:', this.dynComponentMappings);
    let component;
    for (const dynComponentMapping of this.dynComponentMappings) {
      component = dynComponentMapping[this.config.type];
      if (component) {
        break;
      }
    }
    // console.log('control roles:', this.config);
    if (
      this.dynamicService.activeFormResponse &&
      this.config.accessRoleIds &&
      !this.config.isFormBuilder
    ) {
      this.store.dispatch(UserActions.loadRoles());

      combineLatest([
        this.store.select(UserState.selectSecurityRoles),
        this.store.select(UserState.selectCurrent),
      ]).subscribe(([roles, info]) => {
        if (roles) {
          const userRoles = roles?.map((r) => r.roleId);
          const canAccess =
            this.config.accessRoleIds
              .split(',')
              .some((controlRoleId) =>
                userRoles?.includes(controlRoleId.toLowerCase())
              ) ||
            info.UserId === this.dynamicService.activeFormResponse.createdBy;
          if (!canAccess) {
            // console.log('RESTRICTED! ', this.config.formControlName)
            component = this.dynComponentMappings[0]['redacted'];
          }
        }
      });
    }
    if (component) {
      this.component = this.vcRef.createComponent(component);

      // setInput (not direct instance assignment) so the child is marked for check.
      // Direct `instance.x =` never dirties an OnPush view; setInput does. Behavior is
      // identical under zone.js Default CD, and this readies the leaves for OnPush (WI 31903).
      this.component.setInput('config', this.config);
      this.component.setInput('group', this.group);
      this.component.setInput('dynamicService', this.dynamicService);
    } else {
      console.error(
        `Component for ControlType '${this.config.type}' not found. Most likely a developer needs to implement it for this platform.`
      );
    }
  }

  ngOnChanges() {
    if (this.component) {
      this.component.setInput('config', this.config);
      this.component.setInput('group', this.group);
      this.component.setInput('dynamicService', this.dynamicService);
    }
  }
}
